import React from 'react';

const DEFAULT_ERROR_MESSAGE = `
	There has been an error.
	Please refresh the page you came from and try the link again.
`;

interface RedirectSplashProps {
	hasFailure: boolean;
	description?: string;
}

export default function RedirectSplash({
	hasFailure,
	description = DEFAULT_ERROR_MESSAGE,
}: RedirectSplashProps): JSX.Element {
	return (
		<>
			{!hasFailure && (
				<div>
					&nbsp;
				</div>
			)}
			{hasFailure && (
				<div style={{
					marginTop: '25%',
					textAlign: 'center',
				}}>
					{description}
				</div>
			)}
		</>
	);
}
